'use strict';

/* global $ */

import { breakpoints } from '../settings';
import { Responsive } from './responsive';

function Menu(options) {

    let opt = $.extend({
        selector: '.js-header-menu',
        itemSelector: '.js-menu-block',
        linkSelector: '.js-header-link',
        submenuSelector: '.js-submenu',
        subitemSelector: '.js-submenu-item',
        sublinkSelector: '.js-submenu-link',
        subsubmenuSelector: '.js-subsubmenu',
        arrowSelector: '.js-menu-arrow',
        duration: 75,
        hide_duration: 0,
        delay: 5
    }, options);

    function initMenu(el) {
        let $menu = $(el),
            $items = $menu.find(opt.itemSelector);

        function initItem(el) {
            let $item = $(el),
                $link = $(opt.linkSelector, el),
                $submenu = $(opt.submenuSelector, el),
                $arrow = $(opt.arrowSelector, el);
            function checkMenu() {
                clearTimer($submenu);

                let isOver = $link.data('isOver') || $submenu.data('isOver');
                $submenu.data('timer', setTimeout(function() {
                    if (isOver) {
                        show();
                    } else {
                        hide();
                    }
                }, opt.delay));
            }

            function toggleMenu() {
                if ($submenu.hasClass('is-hidden')) {
                    $(opt.itemSelector).removeClass('is-active');
                    $(opt.submenuSelector).addClass('is-hidden');
                    $item.addClass('is-active');
                    $submenu.removeClass('is-hidden');
                } else {
                    $item.removeClass('is-active');
                    $submenu.addClass('is-hidden');
                }
            }

            function clearTimer() {
                if ($submenu.data('timer')) {
                    clearTimeout($submenu.data('timer'));
                    $submenu.removeData('timer');
                }
            }

            function show() {
                $submenu.stop(true).removeClass('is-hidden').animate({
                    top: '32px',
                    opacity: 1
                }, {
                    duration: opt.duration
                });
            }

            function hide() {
                $submenu.stop(true).animate({
                    top: '16px',
                    opacity: 0
                }, {
                    duration: opt.hide_duration,
                    complete: function() {
                        $submenu.addClass('is-hidden');
                    }
                });
            }

            function unbindEvents() {
                $link.off('mouseover mouseout click tap');
            }

            function bindEvents() {
                if ( window.innerWidth > breakpoints.xs) {

                    $link.on('mouseover', function() {
                        $link.data('isOver', true);
                        checkMenu();
                    }).on('mouseout', function() {
                        $link.data('isOver', false);
                        checkMenu();
                    });

                    $submenu.on('mouseover', function() {
                        $submenu.data('isOver', true);
                        checkMenu();
                    }).on('mouseout', function() {
                        $submenu.data('isOver', false);
                        checkMenu();
                    });

                    $arrow.on('click tap', function(e) {

                        e.preventDefault();
                        e.stopPropagation();

                        toggleMenu();
                    });
                } else {
                    $link.on('click tap', function(e) {
                        // e.preventDefault();
                        e.stopPropagation();

                        toggleMenu();
                    });

                    $arrow.on('click tap', function(e) {

                        e.preventDefault();
                        e.stopPropagation();

                        toggleMenu();
                    });
                }
            }

            function initSubitem(el) {
                let $subitem = $(el),
                    $sublink = $(opt.sublinkSelector, el),
                    $subsubmenu = $(opt.subsubmenuSelector, el);


                function toggleSubmenu() {
                    if ($subsubmenu.hasClass('is-hidden')) {
                        $(opt.subitemSelector).removeClass('is-active');
                        $(opt.subsubmenuSelector).addClass('is-hidden');
                        $subitem.addClass('is-active');
                        $subsubmenu.removeClass('is-hidden');
                    } else {
                        $subitem.removeClass('is-active');
                        $subsubmenu.addClass('is-hidden');
                    }
                }

                if ( window.innerWidth > breakpoints.xs) {
                    $subitem.on('mouseover', function() {
                        toggleSubmenu();
                    }).on('mouseout', function() {
                        toggleSubmenu();
                    });
                } else {
                    $subitem.on('click tap', function(e) {

                        e.preventDefault();
                        e.stopPropagation();

                        toggleMenu();
                    });
                }


                $sublink.on('click tap', function(e) {
                    // e.preventDefault();
                    e.stopPropagation();

                    toggleSubmenu();
                });
            }
            if ($submenu.length) {

                bindEvents();

                $(window).on('resize', function(e, data) {
                    unbindEvents();
                    bindEvents();
                });

                $submenu.find(opt.subitemSelector).each(function() {
                    if ($(this).hasClass('m--submenu')) {
                        initSubitem(this);
                    }
                });
            }
        }

        $(opt.itemSelector, el).each(function() {
            if ($(this).hasClass('m--submenu')) {
                initItem(this);
            }
        })
    }

    $(opt.selector).each(function() {
        initMenu(this); 
    });

}

export {
    Menu
};